<h2 mat-dialog-title>Report Options</h2>
<mat-dialog-content class="dialog-content-no-scroll">
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Element Ordering</mat-label>
    <mat-select [(value)]="selectedId">
      <mat-option *ngFor="let def of data.orderingDefinitions" [value]="def.id">{{def.name}}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Report Language</mat-label>
    <mat-select [(value)]="language">
      <mat-option value="en">English</mat-option>
      <mat-option value="af">Afrikaans</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-checkbox *ngIf="showCombinedOption" [(ngModel)]="combined" style="margin-top: 8px; margin-bottom: 12px;">
    Include Top Soil &amp; Sub Soil (Combined Report)
  </mat-checkbox>

  <mat-expansion-panel style="margin-top: 12px; box-shadow: none;">
    <mat-expansion-panel-header>
      <mat-panel-title style="font-size: 12px; font-weight: 500;">Advanced Settings</mat-panel-title>
    </mat-expansion-panel-header>

    <mat-form-field appearance="outline" style="width: 100%; padding-top: 12px;">
      <mat-label>Page Orientation</mat-label>
      <mat-select [(value)]="orientation">
        <mat-option value="portrait">Portrait</mat-option>
        <mat-option value="landscape">Landscape</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Label Size (px) — leave empty for auto</mat-label>
      <input matInput type="number" [(ngModel)]="labelSize" min="8" max="50" placeholder="Auto">
    </mat-form-field>

    <div style="display: flex; gap: 12px; margin-bottom: 12px; align-items: center;">
      <div style="flex: 1;">
        <label style="font-size: 11px; color: rgba(0,0,0,0.6);">Label Colour</label>
        <input type="color" [(ngModel)]="labelColor" style="width: 100%; height: 32px; border: 1px solid #ccc; border-radius: 4px; cursor: pointer;">
      </div>
      <div style="flex: 1;">
        <label style="font-size: 11px; color: rgba(0,0,0,0.6);">Stroke Colour</label>
        <input type="color" [(ngModel)]="labelStrokeColor" [disabled]="!strokeEnabled" style="width: 100%; height: 32px; border: 1px solid #ccc; border-radius: 4px; cursor: pointer;">
      </div>
    </div>
    <mat-checkbox [(ngModel)]="strokeEnabled" style="margin-bottom: 12px; font-size: 12px;">
      Enable label stroke/outline
    </mat-checkbox>

    <mat-form-field appearance="outline" style="width: 100%;" *ngIf="availableFields.length > 0">
      <mat-label>Select Fields</mat-label>
      <mat-select [(value)]="selectedFieldIds" multiple>
        <mat-option *ngFor="let field of availableFields" [value]="field.id">{{field.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="selectedFieldIds.length > 0" class="selected-field-list">
      <div *ngFor="let id of selectedFieldIds" class="selected-field-item">
        <p class="selected-field-name">{{getFieldName(id)}}</p>
        <div class="remove-selected-field-item" (click)="removeField(id)">x</div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" class="dialog-actions-btn" (click)="onConfirm()">Download</button>
</mat-dialog-actions>
